module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Kick1.960668c0.png";